
import InfiniteMenu from './infinitemenu';

export const VerticalSelectController = () => {
  if(typeof ScrollMagic === 'undefined') return;

  let scenes = [];
  let controller;

  setUpMenu();
  setUpScenes(scenes, controller);

  $(document).on('scroll', () => {
    updateScene(scenes);
    updateMenu();
  })
}


const setUpMenu = () => {
  $('.scroll-menu').each((i, menu) => {
    setMenuHeight(menu);
    setActiveMenuItem(menu);

    $(menu).find('.scroll-menu__item').each((i, el) => {
      $(document).on('mouseover', '.scroll-menu__item',  (e) => {
        $(menu).find('.scroll-menu__item').removeClass('active');
        $(e.currentTarget).addClass('active');
      })
    });
    const scrollerMenu = new InfiniteMenu(menu);
  })
}

const updateMenu = () => {
  $('.scroll-menu').each((i, menu) => {
    setMenuHeight(menu);
    setActiveMenuItem(menu);
  })
}

const setMenuHeight = (menu) => {
  const items = parseInt($(menu).attr('data-items'));
  const itemHeight = $(menu).find('.scroll-menu__item').height();
  $(menu).height(items * itemHeight);


}

const setActiveMenuItem = (menu) => {
  const items = parseInt($(menu).attr('data-items'));
  const pos = Math.round(items / 2) - 1;
  $(menu).find('.scroll-menu__item').eq(pos).addClass('active');
}




// ScrollMagic To delete??
const setUpScenes = (scenes, controller) => {
  const element = document.querySelector('.scroll-select__list');
  const $sections = $('.scroll-menu__item');
  controller = new ScrollMagic.Controller();

  $sections.each((i, el) => {
    const height = $(el).outerHeight();
    let offset = (height / 2);
    let duration = height;

    let scene = new ScrollMagic.Scene({
        triggerElement: el,
        triggerHook: setTriggerPos(element),
        offset: offset,
        duration: duration
      })
      .setClassToggle(el, "active")
      .addTo(controller);

    scenes.push(scene);
  })
}


const updateScene = (scenes) => {
  var element = document.querySelector('.scroll-select__list');
  for (var i = 0; i < scenes.length; i++) {
    scenes[i].triggerHook(setTriggerPos(element));
    scenes[i].refresh();
  }
}



const getAbsPosition = (el) => {
  const {
    top: t,
    left: l
  } = el.getBoundingClientRect();
  const {
    scrollX,
    scrollY
  } = window

  const topPos = t + scrollX
  const leftPos = l + scrollY
  return [topPos, leftPos];
};


const getDivCenter = (el) => {
  const pos = getAbsPosition(el);
  const top = pos[0];
  const height = el.offsetHeight
  const center = top + (height / 2)
  return center;
}


const setTriggerPos = (el) => {
  let divCenter = getDivCenter(el)
  let windowHeight = window.innerHeight;
  let middle = (divCenter / window.innerHeight);

  return middle;
}



// WEBPACK FOOTER //
// ./src/js/controllers/VerticalSelectController.js